// A classroom session has no student, assessment, score or completion contract.
const pick = (items, random) => items[Math.min(items.length - 1, Math.floor(random() * items.length))];
const validPool = entries => [...new Map(entries.filter(e => e.text && e.audio?.url && e.audio?.sha256).map(e => [e.text, e])).values()];
const leastUsed = (entries, uses, random) => {
  const minimum = Math.min(...entries.map(e => uses[e.text] || 0));
  return pick(entries.filter(e => (uses[e.text] || 0) === minimum), random);
};
export function newBalloonSession(entries, random = Math.random) {
  const pool = validPool(entries);
  if (pool.length < 3) return null;
  const available = [...pool], slots = [];
  while (slots.length < 3) {
    const item = pick(available, random);
    available.splice(available.indexOf(item), 1);
    slots.push({ word: item.text, color: slots.length, nonce: 0 });
  }
  return { pool, slots, target: pick(slots, random).word, uses: {}, step: 0 };
}
export function nextBalloonChallenge(session, popped, entries, random = Math.random) {
  const pool = validPool(entries);
  if (pool.length < 3) return null;
  const uses = { ...session.uses, [session.target]: (session.uses[session.target] || 0) + 1 };
  const slots = [...session.slots];
  const allowed = new Set(pool.map(e => e.text));
  // On a settings change, retire invalid distractors at the next challenge too.
  // During ordinary play this changes exactly the popped slot.
  const refresh = slots.map((slot, i) => i === popped || !allowed.has(slot.word));
  for (let i = 0; i < slots.length; i += 1) {
    if (!refresh[i]) continue;
    const neighbours = slots.filter((_, j) => j !== i && !refresh[j]).map(s => s.word);
    const choices = pool.filter(e => !neighbours.includes(e.text));
    const fresh = choices.filter(e => e.text !== slots[i].word);
    const entry = leastUsed(fresh.length ? fresh : choices, uses, random);
    slots[i] = { word: entry.text, color: (slots[i].color + 1) % 6, nonce: slots[i].nonce + 1 };
    refresh[i] = false;
  }
  const alternatives = slots.filter((slot, i) => i !== popped && slot.word !== session.target);
  const eligible = alternatives.length ? alternatives : slots.filter(s => s.word !== session.target);
  const target = leastUsed(eligible.map(s => ({ text: s.word })), uses, random).text;
  return { pool, slots, target, uses, step: session.step + 1 };
}
